import { FC } from 'react'

export const Dashboard: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_132_228)">
      <path
        d="M10.5681 5.32851e-05H5.40007C3.96856 0.00216935 2.59628 0.571774 1.58405 1.58401C0.571812 2.59624 0.00220762 3.96852 9.15527e-05 5.40004V10.6C0.00220762 12.0315 0.571812 13.4038 1.58405 14.416C2.59628 15.4283 3.96856 15.9979 5.40007 16H10.6001C12.0316 15.9979 13.4038 15.4283 14.4161 14.416C15.4283 13.4038 15.9979 12.0315 16 10.6V5.40004C15.999 4.6885 15.8575 3.98416 15.5838 3.32739C15.3101 2.67062 14.9094 2.07433 14.4048 1.57268C13.9002 1.07104 13.3015 0.673904 12.6431 0.404042C11.9847 0.13418 11.2796 -0.00310519 10.5681 5.32851e-05ZM5.14407 11.384C5.14407 11.5538 5.07665 11.7165 4.95662 11.8366C4.8366 11.9566 4.67381 12.024 4.50408 12.024C4.33434 12.024 4.17155 11.9566 4.05153 11.8366C3.93151 11.7165 3.86408 11.5538 3.86408 11.384V7.30403C3.86408 7.13429 3.93151 6.97151 4.05153 6.85148C4.17155 6.73146 4.33434 6.66403 4.50408 6.66403C4.67381 6.66403 4.8366 6.73146 4.95662 6.85148C5.07665 6.97151 5.14407 7.13429 5.14407 7.30403V11.384ZM8.70406 11.384C8.70406 11.4681 8.68751 11.5513 8.65535 11.6289C8.62318 11.7066 8.57604 11.7771 8.51661 11.8366C8.45718 11.896 8.38663 11.9431 8.30898 11.9753C8.23133 12.0075 8.14811 12.024 8.06406 12.024C7.98002 12.024 7.8968 12.0075 7.81915 11.9753C7.7415 11.9431 7.67095 11.896 7.61152 11.8366C7.55209 11.7771 7.50495 11.7066 7.47278 11.6289C7.44062 11.5513 7.42407 11.4681 7.42407 11.384V4.62404C7.42407 4.4543 7.4915 4.29151 7.61152 4.17149C7.73154 4.05147 7.89433 3.98404 8.06406 3.98404C8.2338 3.98404 8.39659 4.05147 8.51661 4.17149C8.63663 4.29151 8.70406 4.4543 8.70406 4.62404V11.384ZM12.0721 11.384C12.0721 11.5538 12.0046 11.7165 11.8846 11.8366C11.7646 11.9566 11.6018 12.024 11.4321 12.024C11.2623 12.024 11.0995 11.9566 10.9795 11.8366C10.8595 11.7165 10.7921 11.5538 10.7921 11.384V6.25603C10.7921 6.08629 10.8595 5.92351 10.9795 5.80349C11.0995 5.68346 11.2623 5.61604 11.4321 5.61604C11.6018 5.61604 11.7646 5.68346 11.8846 5.80349C12.0046 5.92351 12.0721 6.08629 12.0721 6.25603V11.384Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_228">
        <rect width="15.9999" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const Knowledge: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_132_234)">
      <path
        d="M14.1329 14.9999C13.544 14.9999 13.0387 15.3654 12.8296 15.8822H11.6017V16.9411H12.8296C13.0387 17.4579 13.544 17.8234 14.1329 17.8234C14.9084 17.8234 15.5392 17.1901 15.5392 16.4116C15.5392 15.6332 14.9084 14.9999 14.1329 14.9999Z"
        fill="currentColor"
      />
      <path
        d="M16.5939 12.0001C16.3628 12.0001 16.1447 12.0567 15.9521 12.1564L14.6463 11.064C14.5516 10.9847 14.4321 10.9413 14.3087 10.9413H11.6017V12.0001H14.1178L15.2627 12.9579C15.2143 13.1005 15.1876 13.253 15.1876 13.4119C15.1876 14.1903 15.8185 14.8236 16.5939 14.8236C17.3693 14.8236 18.0002 14.1903 18.0002 13.4119C18.0002 12.6334 17.3693 12.0001 16.5939 12.0001Z"
        fill="currentColor"
      />
      <path
        d="M16.5939 7.58826C16.0049 7.58826 15.4997 7.95376 15.2906 8.47061H11.6017V9.52943H15.2906C15.4997 10.0463 16.0049 10.4118 16.5939 10.4118C17.3693 10.4118 18.0002 9.77847 18.0002 9.00002C18.0002 8.22157 17.3693 7.58826 16.5939 7.58826Z"
        fill="currentColor"
      />
      <path
        d="M14.6463 6.93603L15.9521 5.84364C16.1447 5.94331 16.3628 5.99992 16.5939 5.99992C17.3693 5.99992 18.0002 5.3666 18.0002 4.58816C18.0002 3.80971 17.3693 3.17639 16.5939 3.17639C15.8185 3.17639 15.1876 3.80971 15.1876 4.58816C15.1876 4.74698 15.2143 4.89956 15.2627 5.04211L14.1178 5.99992H11.6017V7.05874H14.3087C14.4321 7.05874 14.5516 7.01533 14.6463 6.93603Z"
        fill="currentColor"
      />
      <path
        d="M14.1329 3.00017C14.9084 3.00017 15.5392 2.36685 15.5392 1.5884C15.5392 0.809954 14.9084 0.176636 14.1329 0.176636C13.544 0.176636 13.0387 0.542142 12.8296 1.05899H11.6017V2.11781H12.8296C13.0387 2.63466 13.544 3.00017 14.1329 3.00017Z"
        fill="currentColor"
      />
      <path
        d="M5.27353 9.00019C5.27353 11.0436 6.92952 12.7061 8.96499 12.7061C9.53084 12.7061 10.0673 12.5774 10.547 12.348V5.65237C10.0673 5.42296 9.53084 5.29431 8.96499 5.29431C6.92952 5.29431 5.27353 6.95677 5.27353 9.00019Z"
        fill="currentColor"
      />
      <path
        d="M10.0198 0H7.91036C7.61912 0 7.38301 0.237035 7.38301 0.529412V1.21853C6.39345 1.42091 5.44647 1.81475 4.60295 2.37473L4.11744 1.88735C3.91149 1.6806 3.57761 1.6806 3.37166 1.88735L1.8801 3.38474C1.67415 3.59146 1.67415 3.92668 1.8801 4.13344L2.36558 4.62085C1.80778 5.46766 1.41547 6.41834 1.21388 7.41177H0.527443C0.236204 7.41177 9.15527e-05 7.6488 9.15527e-05 7.94118V10.0588C9.15527e-05 10.3512 0.236204 10.5882 0.527443 10.5882H1.21388C1.41547 11.5817 1.80778 12.5323 2.36558 13.3792L1.88006 13.8666C1.78117 13.9659 1.72562 14.1005 1.72562 14.2409C1.72562 14.3813 1.78117 14.5159 1.88006 14.6152L3.37166 16.1126C3.57761 16.3194 3.91149 16.3194 4.11744 16.1126L4.60295 15.6253C5.44647 16.1852 6.39345 16.5791 7.38301 16.7815V17.4706C7.38301 17.763 7.61912 18 7.91036 18H10.0198C10.311 18 10.5471 17.763 10.5471 17.4706V13.4922C10.052 13.6684 9.51959 13.7647 8.96506 13.7647C6.34803 13.7647 4.2189 11.6273 4.2189 9C4.2189 6.37274 6.34803 4.23529 8.96506 4.23529C9.51959 4.23529 10.052 4.33158 10.5471 4.50784V0.529412C10.5471 0.237035 10.311 0 10.0198 0Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_234">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const Quiz: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_132_245)">
      <path
        d="M0.555054 2.32031L1.30064 1.57472L2.85309 3.12717L2.1075 3.87276L0.555054 2.32031Z"
        fill="currentColor"
      />
      <path d="M0 5.27344H2.14661V6.32812H0V5.27344Z" fill="currentColor" />
      <path
        d="M0.56665 9.26782L2.11756 7.71691L2.86315 8.4625L1.31224 10.0134L0.56665 9.26782Z"
        fill="currentColor"
      />
      <path
        d="M15.1445 3.12878L16.697 1.57634L17.4426 2.32193L15.8901 3.87437L15.1445 3.12878Z"
        fill="currentColor"
      />
      <path
        d="M15.8534 5.27344H18V6.32812H15.8534V5.27344Z"
        fill="currentColor"
      />
      <path
        d="M15.1331 8.46387L15.8786 7.71828L17.4296 9.26918L16.684 10.0148L15.1331 8.46387Z"
        fill="currentColor"
      />
      <path
        d="M9 18C10.4538 18 11.6367 16.8171 11.6367 15.3633V13.7109H6.36328V15.3633C6.36328 16.8171 7.54618 18 9 18Z"
        fill="currentColor"
      />
      <path
        d="M14.7122 4.77647C14.2332 2.00897 11.8308 0 8.99999 0C6.16914 0 3.76674 2.00897 3.2878 4.777C2.95614 6.6948 3.59011 8.63888 4.98364 9.97629C5.73011 10.6929 6.1838 11.6503 6.3085 12.6562H11.6916C11.8164 11.6498 12.27 10.6928 13.0163 9.97629C14.4099 8.63888 15.0438 6.6948 14.7122 4.77647ZM9.52733 9.49219H8.47265V8.4375H9.52733V9.49219ZM9.93733 6.02061C9.68058 6.20965 9.52733 6.51241 9.52733 6.83058V7.38281H8.47265V6.83058C8.47265 6.17854 8.78642 5.55827 9.312 5.17131C9.44887 5.07055 9.52733 4.91558 9.52733 4.74609C9.52733 4.45532 9.29077 4.21875 8.99999 4.21875C8.70921 4.21875 8.47265 4.45532 8.47265 4.74609V5.27344H7.41796V4.74609C7.41796 3.87376 8.12766 3.16406 8.99999 3.16406C9.87232 3.16406 10.582 3.87376 10.582 4.74609C10.582 5.24693 10.341 5.7234 9.93733 6.02061Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_245">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const Form: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_132_258)">
      <path
        d="M10.6802 3.35252H5.67419C5.19861 3.35252 4.81268 2.92632 4.81268 2.40112V0.951522C4.81268 0.426324 5.19861 0.00012207 5.67419 0.00012207H10.6802C11.1558 0.00012207 11.5417 0.426324 11.5417 0.951522V2.40112C11.5417 2.92696 11.1558 3.35252 10.6802 3.35252Z"
        fill="currentColor"
      />
      <path
        d="M16.4687 10.2793C15.9331 9.68784 15.06 9.68784 14.5245 10.2793L13.8888 10.9851L15.8342 13.1328L16.4687 12.4321C17.01 11.8349 17.01 10.8771 16.4687 10.2793Z"
        fill="currentColor"
      />
      <path
        d="M13.2733 11.6676L9.87968 15.4089C9.80983 15.4925 9.76326 15.5953 9.7458 15.7046L9.48967 17.3696C9.43146 17.736 9.72251 18.051 10.0543 17.9931L11.5619 17.7103C11.6609 17.691 11.754 17.6396 11.8239 17.5624L15.2175 13.8147L13.2733 11.6676Z"
        fill="currentColor"
      />
      <path
        d="M13.1393 1.67798H12.4146V2.40117C12.4146 3.45735 11.6364 4.31683 10.68 4.31683H5.67396C4.71699 4.31683 3.93931 3.45735 3.93931 2.40117V1.67798H3.20296C2.05623 1.67798 1.12488 2.70652 1.12488 3.97291V15.7047C1.12488 16.9711 2.05623 17.9996 3.20296 17.9996H8.70785C8.61937 17.7483 8.58619 17.4757 8.62926 17.2038L8.8848 15.5434C8.93021 15.2489 9.05245 14.977 9.23639 14.7552L12.9414 10.6694L13.9048 9.59967C14.2628 9.20368 14.7221 8.96905 15.2163 8.90155V3.97934C15.2174 2.70009 14.2919 1.67798 13.1393 1.67798ZM7.27065 11.2132H4.74494C4.45563 11.2132 4.22105 10.9541 4.22105 10.6346C4.22105 10.3152 4.45563 10.0561 4.74494 10.0561H7.27065C7.55995 10.0561 7.79454 10.3152 7.79454 10.6346C7.79454 10.9541 7.55995 11.2132 7.27065 11.2132ZM10.3627 7.92958H4.74552C4.45621 7.92958 4.22163 7.67052 4.22163 7.35103C4.22163 7.03153 4.45621 6.77247 4.74552 6.77247H10.3627C10.652 6.77247 10.8866 7.03153 10.8866 7.35103C10.8866 7.67052 10.652 7.92958 10.3627 7.92958Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_258">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const Users: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_132_272)">
      <path
        d="M3 6.75C4.24264 6.75 5.25 5.74264 5.25 4.5C5.25 3.25736 4.24264 2.25 3 2.25C1.75736 2.25 0.75 3.25736 0.75 4.5C0.75 5.74264 1.75736 6.75 3 6.75Z"
        fill="currentColor"
      />
      <path
        d="M5.4675 8.3025C4.71262 8.77355 4.09004 9.42896 3.65837 10.207C3.22669 10.9851 3.00013 11.8602 3 12.75H1.5C1.10254 12.7488 0.721699 12.5904 0.440651 12.3093C0.159603 12.0283 0.00118705 11.6475 0 11.25L0 9.75C0.00178057 9.15381 0.239405 8.58255 0.660977 8.16098C1.08255 7.7394 1.65381 7.50178 2.25 7.5H3.75C4.07743 7.50074 4.40075 7.57293 4.69739 7.71154C4.99404 7.85014 5.25685 8.05182 5.4675 8.3025Z"
        fill="currentColor"
      />
      <path
        d="M15 6.75C16.2426 6.75 17.25 5.74264 17.25 4.5C17.25 3.25736 16.2426 2.25 15 2.25C13.7574 2.25 12.75 3.25736 12.75 4.5C12.75 5.74264 13.7574 6.75 15 6.75Z"
        fill="currentColor"
      />
      <path
        d="M18 9.75V11.25C17.9988 11.6475 17.8404 12.0283 17.5594 12.3093C17.2783 12.5904 16.8975 12.7488 16.5 12.75H15C14.9999 11.8602 14.7733 10.9851 14.3416 10.207C13.91 9.42896 13.2874 8.77355 12.5325 8.3025C12.7431 8.05182 13.006 7.85014 13.3026 7.71154C13.5993 7.57293 13.9226 7.50074 14.25 7.5H15.75C16.3462 7.50178 16.9175 7.7394 17.339 8.16098C17.7606 8.58255 17.9982 9.15381 18 9.75Z"
        fill="currentColor"
      />
      <path
        d="M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z"
        fill="currentColor"
      />
      <path
        d="M13.5 12.75V13.5C13.4982 14.0962 13.2606 14.6675 12.839 15.089C12.4175 15.5106 11.8462 15.7482 11.25 15.75H6.75C6.15381 15.7482 5.58255 15.5106 5.16098 15.089C4.73941 14.6675 4.50178 14.0962 4.5 13.5V12.75C4.5 11.7554 4.89509 10.8016 5.59835 10.0983C6.30161 9.39509 7.25544 9 8.25 9H9.75C10.7446 9 11.6984 9.39509 12.4017 10.0983C13.1049 10.8016 13.5 11.7554 13.5 12.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_272">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const Agent: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.51941 5.87167C5.51941 5.30369 5.68785 4.74845 6.00344 4.27619C6.31902 3.80393 6.76757 3.43584 7.29237 3.21848C7.81717 3.00112 8.39464 2.94425 8.95176 3.05506C9.50889 3.16587 10.0206 3.43938 10.4223 3.84101C10.824 4.24264 11.0975 4.75434 11.2083 5.31141C11.3191 5.86849 11.2623 6.44591 11.0449 6.97066C10.8275 7.49541 10.4594 7.94393 9.98708 8.25948C9.51477 8.57504 8.95949 8.74347 8.39146 8.74347C7.62974 8.74347 6.89923 8.44091 6.36061 7.90234C5.822 7.36377 5.51941 6.63332 5.51941 5.87167ZM12.734 11.3855C12.7246 11.3192 12.6924 11.2583 12.6428 11.2132C12.266 10.8603 11.8219 10.5869 11.3371 10.4093C10.8523 10.2316 10.3367 10.1535 9.82102 10.1794H6.94897C4.03384 10.1794 2.99991 12.3117 2.99991 14.1424C2.99991 15.7794 3.8687 16.6409 5.51295 16.6409H9.24661C9.27492 16.6417 9.30308 16.6364 9.32911 16.6252C9.35515 16.614 9.37845 16.5973 9.39739 16.5763C9.43733 16.5346 9.46037 16.4796 9.46201 16.4219V15.205C9.46226 14.9195 9.5759 14.6458 9.77794 14.444L12.6715 11.5363C12.7107 11.4958 12.7331 11.4419 12.734 11.3855ZM10.539 15.205V16.9999H12.3341L15.5931 13.7555L13.7844 11.947L10.539 15.205ZM16.7915 11.5514L15.9873 10.7473C15.8528 10.6135 15.6708 10.5385 15.4811 10.5385C15.2914 10.5385 15.1094 10.6135 14.9749 10.7473L14.2863 11.4437L16.095 13.2522L16.7915 12.5637C16.925 12.4292 16.9999 12.2474 16.9999 12.0579C16.9999 11.8684 16.925 11.6859 16.7915 11.5514Z"
      fill="currentColor"
    />
  </svg>
)
